import { useRequest } from 'features/request/useRequest';

import * as R from 'ramda';
import { useMemo } from 'react';

import { gqlWorkOrderVersionObjects } from '../../WorkOrderVersion/workOrderVersionQueries';

export const useConstructionTypeVersion = (workOrderVersionId: number) => {
    const variables = useMemo(() => ({ workOrderVersionId }), [workOrderVersionId]);

    const [data, statusConstructionTypes] = useRequest({
        requestId: 'constructionTypeVersion',
        query: gqlWorkOrderVersionObjects,
        variables,
    });

    const constructionTypes = useMemo(
        () =>
            R.uniqBy((i) => i?.id, data?.uerWorkOrderVersionObjects?.items?.map((item) => item.constructionType) ?? []),
        [data?.uerWorkOrderVersionObjects],
    );

    return { constructionTypes, statusConstructionTypes };
};
